const envUrl = process.env.REACT_APP_BACKEND_URL || "";

function getApiBase() {
    if (!envUrl) return "";
    if (typeof window === "undefined") return envUrl;
    try {
        const envOrigin = new URL(envUrl).origin;
        if (envOrigin === window.location.origin) return envUrl;
    } catch {}
    return "";
}

export const API_BASE = getApiBase();
